import React, { useEffect } from 'react';
import { Form, Input, Button, Row, Col, Divider, Space, Card } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';

const { TextArea } = Input;

function FurnizorForm({ initialValues, onSubmit, onCancel }) {
  const [form] = Form.useForm();

  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue({
        ...initialValues,
        rechizite_bancare: initialValues.rechizite_bancare || [{}],
        adresa_fizica: initialValues.adresa_fizica || [{}],
        contact: initialValues.contact || [{}],
        manager_atasat: initialValues.manager_atasat || [{}],
      });
    } else {
      form.resetFields();
      form.setFieldsValue({
        rechizite_bancare: [{}],
        adresa_fizica: [{}],
        contact: [{}],
        manager_atasat: [{}],
      });
    }
  }, [initialValues, form]);

  const handleSubmit = async (values) => {
    // Filtrăm obiectele goale din array-uri
    const cleanedValues = {
      ...values,
      rechizite_bancare: values.rechizite_bancare?.filter(item => 
        item && (item.iban || item.bic || item.banca)
      ) || [],
      adresa_fizica: values.adresa_fizica?.filter(item => 
        item && (item.tip || item.adresa || item.oras)
      ) || [],
      contact: values.contact?.filter(item => 
        item && (item.nume_prenume || item.telefon || item.email)
      ) || [],
      manager_atasat: values.manager_atasat?.filter(item => 
        item && (item.nume_prenume || item.pozitie || item.telefon)
      ) || [],
    };
    
    await onSubmit(cleanedValues);
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleSubmit}
      className="space-y-4"
    >
      <Card title="Informații de bază" className="mb-4">
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="denumire"
              label="Denumire Furnizor"
              rules={[{ required: true, message: 'Denumirea este obligatorie' }]}
            >
              <Input placeholder="Denumirea furnizorului" />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              name="id_no"
              label="CF"
            >
              <Input placeholder="CF" />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              name="cod_tva"
              label="Cod TVA"
            >
              <Input placeholder="Cod TVA" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="brand_name"
              label="Nume Brand"
            >
              <Input placeholder="Numele brandului/mărcii" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="website"
              label="Website"
            >
              <Input placeholder="https://www.example.com" />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item
          name="adresa_juridica"
          label="Adresa juridică"
        >
          <TextArea rows={2} placeholder="Adresa juridică completă" />
        </Form.Item>
      </Card>

      <Card title="Rechizite bancare" className="mb-4">
        <Form.List name="rechizite_bancare">
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, ...restField }) => (
                <div key={key} className="border rounded-lg p-4 mb-4 bg-gray-50">
                  <Row gutter={16}>
                    <Col span={8}>
                      <Form.Item
                        {...restField}
                        name={[name, 'iban']}
                        label="IBAN"
                      >
                        <Input placeholder="IBAN" />
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <Form.Item
                        {...restField}
                        name={[name, 'bic']}
                        label="BIC/SWIFT"
                      >
                        <Input placeholder="BIC/SWIFT" />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        {...restField}
                        name={[name, 'banca']}
                        label="Banca"
                      >
                        <Input placeholder="Numele băncii" />
                      </Form.Item>
                    </Col>
                    <Col span={2}>
                      <Button
                        type="text"
                        danger
                        icon={<DeleteOutlined />}
                        onClick={() => remove(name)}
                        className="mt-8"
                      />
                    </Col>
                  </Row>
                </div>
              ))}
              <Button
                type="dashed"
                onClick={() => add()}
                icon={<PlusOutlined />}
                className="w-full"
              >
                Adaugă cont bancar
              </Button>
            </>
          )}
        </Form.List>
      </Card>

      <Card title="Adrese fizice" className="mb-4">
        <Form.List name="adresa_fizica">
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, ...restField }) => (
                <div key={key} className="border rounded-lg p-4 mb-4 bg-gray-50">
                  <Row gutter={16}>
                    <Col span={6}>
                      <Form.Item
                        {...restField}
                        name={[name, 'tip']}
                        label="Tip adresă"
                      >
                        <Input placeholder="ex: depozit, sediu" />
                      </Form.Item>
                    </Col>
                    <Col span={10}>
                      <Form.Item
                        {...restField}
                        name={[name, 'adresa']}
                        label="Adresa"
                      >
                        <Input placeholder="Adresa completă" />
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <Form.Item
                        {...restField}
                        name={[name, 'oras']}
                        label="Oraș"
                      >
                        <Input placeholder="Orașul" />
                      </Form.Item>
                    </Col>
                    <Col span={2}>
                      <Button
                        type="text"
                        danger
                        icon={<DeleteOutlined />}
                        onClick={() => remove(name)}
                        className="mt-8"
                      />
                    </Col>
                  </Row>
                  <Form.Item
                    {...restField}
                    name={[name, 'comentariu']}
                    label="Comentariu"
                  >
                    <TextArea rows={2} placeholder="Comentarii despre această adresă" />
                  </Form.Item>
                </div>
              ))}
              <Button
                type="dashed"
                onClick={() => add()}
                icon={<PlusOutlined />}
                className="w-full"
              >
                Adaugă adresă fizică
              </Button>
            </>
          )}
        </Form.List>
      </Card>

      <Card title="Persoane de contact" className="mb-4">
        <Form.List name="contact">
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, ...restField }) => (
                <div key={key} className="border rounded-lg p-4 mb-4 bg-gray-50">
                  <Row gutter={16}>
                    <Col span={8}>
                      <Form.Item
                        {...restField}
                        name={[name, 'nume_prenume']}
                        label="Nume și prenume"
                      >
                        <Input placeholder="Nume și prenume" />
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <Form.Item
                        {...restField}
                        name={[name, 'pozitie']}
                        label="Poziție"
                      >
                        <Input placeholder="Poziția în companie" />
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <Form.Item
                        {...restField}
                        name={[name, 'telefon']}
                        label="Telefon"
                      >
                        <Input placeholder="Număr de telefon" />
                      </Form.Item>
                    </Col>
                    <Col span={2}>
                      <Button
                        type="text"
                        danger
                        icon={<DeleteOutlined />}
                        onClick={() => remove(name)}
                        className="mt-8"
                      />
                    </Col>
                  </Row>
                  <Form.Item
                    {...restField}
                    name={[name, 'email']}
                    label="Email"
                  >
                    <Input placeholder="Adresa de email" />
                  </Form.Item>
                </div>
              ))}
              <Button
                type="dashed"
                onClick={() => add()}
                icon={<PlusOutlined />}
                className="w-full"
              >
                Adaugă persoană de contact
              </Button>
            </>
          )}
        </Form.List>
      </Card>

      <Card title="Termeni comerciali" className="mb-4">
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              name="termen_de_plata"
              label="Termen de plată"
            >
              <Input placeholder="ex: 30 zile" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="termen_de_livrare"
              label="Termen de livrare"
            >
              <Input placeholder="ex: 5-7 zile" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="tip_de_achitare"
              label="Tip de achitare"
            >
              <Input placeholder="ex: transfer bancar" />
            </Form.Item>
          </Col>
        </Row>
      </Card>

      <div className="flex justify-end space-x-2 pt-4 border-t">
        <Button onClick={onCancel}>
          Anulează
        </Button>
        <Button type="primary" htmlType="submit" className="bg-blue-600 hover:bg-blue-700">
          {initialValues ? 'Actualizează' : 'Creează'} Furnizor
        </Button>
      </div>
    </Form>
  );
}

export default FurnizorForm; 